import type { ListingStage } from '@/api/v4/project-listings.api';

import { getSpotlightStageLabel } from './get-spotlight-stage-label';
import type { SpotlightStagePillItem } from './spotlight-stage-pill.types';

const LISTING_STAGE_PRECEDENCE: SpotlightStagePillItem['stage'][] = [
  'deal',
  'investment',
  'pilot',
];

export const getSpotlightCompanyStageForTracking = ({
  editorsChoiceLabel,
  listingStages,
  pills,
}: {
  editorsChoiceLabel: string;
  listingStages: ListingStage[];
  pills: SpotlightStagePillItem[];
}): string | null => {
  for (const stage of LISTING_STAGE_PRECEDENCE) {
    const pill = pills.find(candidate => candidate.stage === stage);

    if (pill) {
      return getSpotlightStageLabel(stage, listingStages, editorsChoiceLabel);
    }
  }

  return null;
};
